/**
 * @generated SignedSource<<e455086bf6ac9138b9592fe96e77e0cb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LessonPlayMode = "ANSWER" | "LISTEN" | "%future added value";
export type StartLessonPlayInput = {
  lessonId: string;
  localDay: any;
  mode: LessonPlayMode;
};
export type LessonAnswerStartMutation$variables = {
  input: StartLessonPlayInput;
};
export type LessonAnswerStartMutation$data = {
  readonly startLessonPlay: {
    readonly id: string;
  };
};
export type LessonAnswerStartMutation = {
  response: LessonAnswerStartMutation$data;
  variables: LessonAnswerStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LessonPlay",
    "kind": "LinkedField",
    "name": "startLessonPlay",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonAnswerStartMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LessonAnswerStartMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "6c16a6cbcf22b100cd9f5000ce744a2e",
    "id": null,
    "metadata": {},
    "name": "LessonAnswerStartMutation",
    "operationKind": "mutation",
    "text": "mutation LessonAnswerStartMutation(\n  $input: StartLessonPlayInput!\n) {\n  startLessonPlay(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "60f0a05c891d87bd29768dd18301dc8c";

export default node;
